import { gql, useMutation } from '@apollo/client'

export const CREATE_PRODUCT = gql`
  mutation ($input: [ProductCreate]) {
    createProducts(input: $input) {
      active
      campaign_id
      configuration
      gps_status
      gpid_list
      id
      name
      publish_date
    }
  }
`

export const useCreateProducts = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_PRODUCT)

  return { mutate, data, loading, error }
}
